module.exports = __webpack_public_path__ + "img/zeitleiste-zoom-plus.a0636643.svg";